import React from 'react';

const Hero = () => {
  return (
    <section
      className="relative overflow-hidden pt-28 sm:pt-36 pb-16 sm:pb-24 px-[5%] bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-900 text-center text-white"
      id="home"
      style={{
        '--navy': '#0f2447',
        '--navy-mid': '#1a3560',
      } as React.CSSProperties}
    >
      <div className="inline-flex items-center gap-2 bg-white/12 border border-white/20 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-wider mb-6 sm:mb-7 relative before:absolute before:w-1.5 before:h-1.5 before:bg-green-400 before:rounded-full before:animate-pulse before:left-2">
        <span aria-hidden="true"></span>Now in Early Access
      </div>
      <h1 className="text-5xl md:text-6xl lg:text-[3.75rem] font-black leading-tight max-w-[820px] mx-auto mb-5 relative">
        From <span className="bg-gradient-to-r from-blue-300 via-blue-400 to-blue-500 bg-clip-text text-transparent font-bold">Lead to Funded</span>
        <br />All in One Place
      </h1>
      <p className="text-lg md:text-xl text-white/75 max-w-[560px] mx-auto mb-11 font-normal leading-relaxed">
        The Business Lending Hub gives brokers and lenders the tools to manage clients, prepare loan packages, match with the right lenders, and close deals faster — without the chaos.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5">
        <button
          type="button"
          onClick={() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-white text-slate-900 px-7 py-3.5 rounded-xl font-bold text-base shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all inline-block"
        >
          Request a Demo
        </button>
        <button
          type="button"
          onClick={() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-white px-7 py-3.5 rounded-xl font-semibold text-base border-2 border-white/40 hover:bg-white/10 hover:border-white/70 transition-all inline-block"
        >
          Join the Waitlist
        </button>
      </div>
      <div className="mt-16 flex flex-wrap items-center justify-center gap-8">
        <div className="text-center">
          <strong className="block text-2xl lg:text-3xl font-black">End-to-End</strong>
          <span className="text-xs uppercase tracking-wide text-white/60">Deal Management Workflow</span>
        </div>
        <div className="hidden md:block w-px h-10 bg-white/20" />
        <div className="text-center">
          <strong className="block text-2xl lg:text-3xl font-black">Built for</strong>
          <span className="text-xs uppercase tracking-wide text-white/60">Broker and Lenders</span>
        </div>
        <div className="hidden md:block w-px h-10 bg-white/20" />
        <div className="text-center">
          <strong className="block text-2xl lg:text-3xl font-black">Secure &</strong>
          <span className="text-xs uppercase tracking-wide text-white/60">Compliant Platform</span>
        </div>
        <div className="hidden md:block w-px h-10 bg-white/20" />
        <div className="text-center">
          <strong className="block text-2xl lg:text-3xl font-black">Faster</strong>
          <span className="text-xs uppercase tracking-wide text-white/60">Deal Closings</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
